AoPS.Utils.initKeyChain(AoPS, "Contests");

AoPS.Contests = (function (Contests) {
	Contests.Router = Backbone.Router.extend({
		initialize: function (options) {
			this.elements = {};
			this.models = {};
			this.models.master = options.master;
			this.myPage = new AoPS.Page.constructPage("contest");

			this.route(/(.*)/, this.showSpecialRegister);
		},

		showSpecialRegister: function () {
			var contest = this.models.master.get("contests").first();
			this.myPage.clearPage({remove_modals: false});
			this.myPage.$el.addClass(contest.get("contest_hash"));
			this.myPage.showElement({
				constructor: _.bind(function () {
					return new AoPS.Contests.Views.ContestSpecialRegisterMain({
						model: contest,
					});
				}, this),
			});
		},
	});

	/**
	 * Let's get started!
	 */
	$(window).on("load", function () {
		// Magical refresh
		AoPS.refreshOnBackButtonLoadWithOldData("contest");

		/**
		 * I usually start by building a master model that
		 *  is the air-traffic controller for everything.
		 */
		var contest_master = new AoPS.Contests.Models.Master(),
			my_router;

		/**
		 * Then we build the router.
		 */
		my_router = new Contests.Router({
			master: contest_master,
		});

		/**
		 * In the router, we construct the myPage object that
		 *  controls what we put on the page.  It has
		 *  a master view whose .el element is what we manage
		 *  to control what goes into the DOM.  Here, we add
		 *  that master element to the main-content window.
		 */
		$("#main-content").prepend(my_router.myPage.el);
		/**
		 * And then we press go.
		 */
		Backbone.history.start({pushState: false, root: "contests"});
	});

	return Contests;
})(AoPS.Contests);
